import { HeaderState } from 'models/HeaderState';
import { Dispatch } from 'redux';
import { createHref } from 'components/Shared/server';
import { historyPushState } from 'store/history/actions';

export const clearModeInQueryString = () => (dispatch: Dispatch, getState: () => HeaderState) => {
  const { location } = getState();
  const newLocation = createHref(location);
  delete newLocation.search.mode;

  dispatch(historyPushState({ url: newLocation }));
};

export const clearSalesTakerInQueryString =
  () => (dispatch: Dispatch, getState: () => HeaderState) => {
    const { location } = getState();
    const newLocation = createHref(location);
    delete newLocation.search.salestaker;

    dispatch(historyPushState({ url: newLocation }));
  };
